// Cached jQuery Deferred instances. Each $.getJSON call is made at most once per page load.
// Callers that bind later receive the already-resolved deferred, so their .done() fires
// immediately without triggering a second HTTP request.
let _pmFetch = null;
let _deptFetch = null;

const _statusData = [
    { text: 'Not Started', value: '0' },
    { text: 'In Progress', value: '1' },
    { text: 'Ready for Review', value: '2' },
];

const getPmFetch = company => {
    if (!_pmFetch) {
        _pmFetch = $.getJSON('/Operations/ScheduleFiveOverview/GetProjectManagers', { company, segment: 'ALL' });
    }
    return _pmFetch;
};

const getDeptFetch = company => {
    if (!_deptFetch) {
        _deptFetch = $.getJSON('/Operations/ScheduleFiveOverview/GetJobDepartments', { company });
    }
    return _deptFetch;
};

export const setupFilterMultiSelects = (prefix, company) => {
    const pmWidget = $(`.${prefix}-pm-filter`)
        .kendoMultiSelect({
            placeholder: 'Select Project Manager...',
            dataTextField: 'projectManagerName',
            dataValueField: 'projectManagerNumber',
            autoBind: false,
            dataSource: { data: [] },
            filter: 'contains',
            autoClose: true,
        })
        .data('kendoMultiSelect');
    getPmFetch(company).done(data => {
        if (pmWidget) pmWidget.dataSource.data(data);
    });

    const deptWidget = $(`.${prefix}-job-dept-filter`)
        .kendoMultiSelect({
            placeholder: 'Select Job Department...',
            dataTextField: 'Description',
            dataValueField: 'Department',
            autoBind: false,
            dataSource: { data: [] },
            autoClose: true,
        })
        .data('kendoMultiSelect');
    getDeptFetch(company).done(data => {
        if (deptWidget) deptWidget.dataSource.data(data);
    });

    $(`.${prefix}-status-filter`).kendoMultiSelect({
        placeholder: 'Select Status...',
        dataTextField: 'text',
        dataValueField: 'value',
        autoBind: true,
        dataSource: { data: _statusData },
        autoClose: true,
    });
};

const getFilterValues = (prefix, filterType) => {
    const widget = $(`.${prefix}-${filterType}[data-role="multiselect"]`).data('kendoMultiSelect');
    const values = widget.value();
    return values;
};

export const buildFilters = prefix => {
    const filters = {};

    const pmValues = getFilterValues(prefix, 'pm-filter');
    if (pmValues?.length) filters.pmNumbers = pmValues.join(',');

    const deptValues = getFilterValues(prefix, 'job-dept-filter');
    if (deptValues?.length) filters.deptCodes = deptValues.join(',');

    const statusValues = getFilterValues(prefix, 'status-filter');
    if (statusValues?.length) filters.statuses = statusValues.join(',');

    return filters;
};

// ---------------------------------------------------------------------------
// Individual Projects tab — client-side grid filtering
// ---------------------------------------------------------------------------

export const jobDeptMatchesFilter = (item, value) => {
    if (!item) return false;
    return item.split(',').includes(value);
};

const getPmFilter = () => {
    const pmValues = getFilterValues('js-overview', 'pm-filter');
    const pmFilter = { filters: [], logic: 'or' };
    $.each(pmValues, (index, value) => {
        pmFilter.filters.push({ field: 'projectManagerNumber', operator: 'contains', value });
    });
    return pmFilter;
};

const getJobDeptFilter = () => {
    const jobDeptValues = getFilterValues('js-overview', 'job-dept-filter');
    const jobDeptFilter = { filters: [], logic: 'or' };
    $.each(jobDeptValues, (index, value) => {
        jobDeptFilter.filters.push({
            field: 'jobDepartmentCode',
            operator: item => jobDeptMatchesFilter(item, value),
            value,
        });
    });
    return jobDeptFilter;
};

const getStatusFilter = () => {
    const statusValues = getFilterValues('js-overview', 'status-filter');
    const statusFilter = { filters: [], logic: 'or' };
    $.each(statusValues, (index, value) => {
        statusFilter.filters.push({ field: 'status', operator: 'eq', value });
    });
    return statusFilter;
};

export const initIndividualFilters = () => {
    $('.js-overview-apply-filters').on('click', function() {
        const filterArray = [];
        const pmFilter = getPmFilter();
        if (pmFilter.filters.length > 0) filterArray.push(pmFilter);
        const jobDeptFilter = getJobDeptFilter();
        if (jobDeptFilter.filters.length > 0) filterArray.push(jobDeptFilter);
        const statusFilter = getStatusFilter();
        if (statusFilter.filters.length > 0) filterArray.push(statusFilter);
        $('.grid.review-grid')
            .data('kendoResourceEntry')
            .dataSource.filter({ filters: filterArray, logic: 'and' });
    });
};

export default initIndividualFilters;
